import { render, staticRenderFns } from "./MsLable.vue?vue&type=template&id=fb7a7750&scoped=true"
import script from "./MsLable.vue?vue&type=script&lang=js"
export * from "./MsLable.vue?vue&type=script&lang=js"
import style0 from "./MsLable.vue?vue&type=style&index=0&id=fb7a7750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7a7750",
  null
  
)

export default component.exports